var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.876 31.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.976 0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M445.311,1871c-8.284,0-15,6.155-15,13.75a12.911,12.911,0,0,0,2.8,7.984l-2.709,6.538a1.25,1.25,0,0,0,1.634,1.633l7.976-3.3a16.125,16.125,0,0,0,5.295.9c8.287,0,15-6.158,15-13.75S453.6,1871,445.311,1871Z",
    transform: "translate(-430.31 -1870.999)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.611 12.06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1033.6,820a1.492,1.492,0,1,0,1.462,1.491A1.481,1.481,0,0,0,1033.6,820Zm8.769,0a1.492,1.492,0,1,0,1.462,1.491A1.481,1.481,0,0,0,1042.374,820Zm-4.384,0a1.492,1.492,0,1,0,1.461,1.491A1.481,1.481,0,0,0,1037.99,820Z",
    transform: "translate(-1032.143 -819.999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.59a0557a.svg";
export { ForwardRef as ReactComponent };